import { HttpModule, Http, XHRBackend, RequestOptions } from '@angular/http';
import { HttpService } from "./http.service";
import { LoaderService } from './loader.service';
import { Router } from '@angular/router';

export function httpFactory(
  backend: XHRBackend,
  defaultOptions: RequestOptions,
  loaderService: LoaderService,
  router: Router) {
    return new HttpService(backend, defaultOptions, loaderService, router) }


// WEBPACK FOOTER //
// ./src/app/shared/_services/http.factory.ts